import {useRef} from "react";
import {Bar, BarChart, CartesianGrid, ErrorBar, Label, Legend, Tooltip, XAxis, YAxis} from "recharts";

/**
 * Shared chart presentation for eval results. Both legacy and cloud evals
 * render through these components — the data sources differ, but each page's
 * view layer adapts its documents into the same chart-data shape
 * (see shared/data/charting.js makeChartData).
 */

export function filterData(data, ...toFilter) {
    return data.filter(val => !toFilter.includes(val.name));
}

export function EvalGraph({data, title, children}) {
    const windowSize = useRef([window.innerWidth, window.innerHeight]);
    const width = windowSize.current[0] * .55;
    const height = 300;

    return(
        <>
            <h1>{title}</h1>
            <BarChart width={width} height={height} data={data}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name">
                    <Label value="Stimuli" position={"insideBottom"} offset={-5} />
                </XAxis>
                <YAxis>
                    <Label value="UVF" angle={-90} position={"insideLeft"} />
                </YAxis>
                <Tooltip />
                <Legend />
                {children}
            </BarChart>
        </>
    )
}

export function ImageGraph({data}) {
    return (
        <EvalGraph data={data} title={"UVF by Tanner Scale for Images"}>
            <Bar dataKey={"Image"} fill={"#ff0000"} />
            <Bar dataKey={"ctrl-Image"} fill={"#0000ff"}>
                <ErrorBar dataKey={"ctrl-Image-Error"} stroke={"black"} direction={"y"} />
            </Bar>
        </EvalGraph>
    );
}

export function SexualizedGraph({data}) {
    return (
        <EvalGraph data={data} title={"UVF by Tanner Scale by Area"}>
            <Bar dataKey={"Face"} fill={"#008000"} />
            <Bar dataKey={"ctrl-Face"} fill={"#8B8000"}>
                <ErrorBar dataKey={"ctrl-Face-Error"} stroke={"black"} direction={"y"} />
            </Bar>
            <Bar dataKey={"Sexualized"} fill={"#ff0000"} />
            <Bar dataKey={"ctrl-Sexualized"} fill={"#0000ff"}>
                <ErrorBar dataKey={"ctrl-Sexualized-Error"} stroke={"black"} direction={"y"} />
            </Bar>
        </EvalGraph>
    )
}

export default function EvalGraphsDisplay({data}) {
    return (
        <>
            <ImageGraph data={data} />
            <SexualizedGraph data={filterData(data, 'AOI_p', 'AOI_np', 'err_p', 'err_np')} />
        </>
    )
}
